function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18,0H2C0.9,0,0,0.9,0,2v18l4-4h2.7c1.1,2.4,3.5,4,6.3,4c3.1,0,5.8-2.1,6.7-4.9c0.2-0.3,0.3-0.7,0.3-1.1V2 C20,0.9,19.1,0,18,0z M13,18c-2.8,0-5-2.2-5-5c0-2.8,2.2-5,5-5s5,2.2,5,5C18,15.8,15.8,18,13,18z M13,6c-3.9,0-7,3.1-7,7 c0,0.3,0,0.7,0.1,1H4l-2,2V2h16v6.1C16.7,6.8,15,6,13,6z M12,15h2v2h-2V15z M12,9h2v4h-2V9z"
});

var SvgSmsReminder = function SvgSmsReminder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmsReminder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sms_reminder.9ce6a4d0.svg";
export { ForwardRef as ReactComponent };